import { StringUtils, Utils } from "neo-common";
import { Platforms } from "neo-games";
import { PlayList } from "../Components/Sounds/PlayList";
import { Languages } from "../Utils/Languages";
import { GameApp } from "../GameApp";
import { AppContext } from "../../Common/AppContext";
import { BaseModel } from "../GameComponents/Base/BaseModel";
import { FreeRoundBonus } from "../Channels/Common/Bonuses/FreeRoundBonus";

export class MessageManager {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    protected static dialog: HTMLElement;

    protected static title: HTMLElement;

    protected static text: HTMLElement;

    protected static buttonsHolder: HTMLElement;

    protected static buttons: Array<HTMLElement>;

    protected static callback: (response: any) => void;

    protected static response: any;

    protected static step: number;

    protected static dialogOpened: boolean = false;

    //******************************************************************************************************************
    //  POSTPONE
    //******************************************************************************************************************

    public static postpone(callback: (response: any) => void, response: any): void {
        if (
            !Utils.isNullOrUndefined(response) &&
            !Utils.isNullOrUndefined(response.messages) &&
            response.messages.length > 0
        ) {
            if (Utils.isNullOrUndefined(MessageManager.dialog)) {
                MessageManager.dialog = document.getElementById("messageDialog");

                if (!Utils.isNullOrUndefined(MessageManager.dialog)) {
                    MessageManager.title = MessageManager.dialog.getElementsByTagName("h3")[0];
                    MessageManager.text = document.getElementById("messageDialogText");

                    MessageManager.buttonsHolder = document.getElementById("messageDialogButtons");
                    MessageManager.buttons = [];
                }
            }

            if (Utils.isNullOrUndefined(MessageManager.dialog)) {
                callback(response);
            } else {
                MessageManager.callback = callback;
                MessageManager.response = response;
                MessageManager.step = 0;
                MessageManager.dialogOpened = false;
                MessageManager.handle();
            }
        } else {
            callback(response);
        }
    }

    //******************************************************************************************************************
    //  UPDATE DIALOG DATA
    //******************************************************************************************************************

    protected static updateDialogData(data: any): void {
        MessageManager.resetDialogData();

        if (!Utils.isNullOrUndefined(data["title"])) {
            MessageManager.title.innerHTML = data["title"];
        }

        if (!Utils.isNullOrUndefined(data["text"])) {
            MessageManager.text.innerHTML = data["text"];
        }

        if (!Utils.isNullOrUndefined(data["actions"])) {
            MessageManager.removeAllButtons();

            for (let i = 0; i < data["actions"].length; i++) {
                let action = data["actions"][i];

                switch (action.type) {
                    case "continue":
                        MessageManager.createButton(action["text"], MessageManager.actionContinue.bind(this, action));
                        break;
                    case "exit":
                        MessageManager.createButton(action["text"], MessageManager.actionExit.bind(this, action));
                        break;
                    case "history":
                        MessageManager.createButton(action["text"], MessageManager.actionHistory.bind(this, action));
                        break;
                    case "reload":
                        MessageManager.createButton(action["text"], MessageManager.actionReload.bind(this, action));
                        break;
                    case "cashier":
                        MessageManager.createButton(action["text"], MessageManager.actionCashier.bind(this, action));
                        break;
                    case "link":
                        MessageManager.createButton(action["text"], MessageManager.actionLink.bind(this, action));
                        break;
                }
            }
        }
    }

    protected static resetDialogData(): void {
        //default title
        MessageManager.title.innerHTML = Languages.getRid("DLG_INFO");

        //remove all custom buttons
        MessageManager.removeAllButtons();

        //create default continue button
        MessageManager.createButton(Languages.getRid("CONTINUE"), MessageManager.actionContinue);
    }

    protected static removeAllButtons(): void {
        while (MessageManager.buttons.length > 0) {
            let button = MessageManager.buttons.pop();
            MessageManager.buttonsHolder.removeChild(button);
        }
    }

    protected static createButton(text: string, action: (data: any) => void): void {
        let button: HTMLElement = document.createElement("div");
        button.textContent = text;
        button.classList.add("dialogBtn", "customDialogBtn");
        button.onclick = action;

        MessageManager.buttonsHolder.appendChild(button);
        MessageManager.buttons.push(button);
    }

    //******************************************************************************************************************
    //  ACTIONS
    //******************************************************************************************************************

    protected static actionContinue(data: any): void {
        PlayList.play("SND_Click");
        MessageManager.handle();
    }

    protected static actionExit(data: any): void {
        PlayList.play("SND_Click");
        Platforms.Platforms.exitHandler = "messageDialog";
        GameApp.exit();
    }

    protected static actionReload(data: any): void {
        PlayList.play("SND_Click");
        Platforms.Platforms.gameReloading();
        if (Platforms.Platforms.handleGameReload) {
            return;
        }

        window.location.reload(true);
    }

    protected static actionHistory(data: any): void {
        PlayList.play("SND_Click");

        if (!Utils.isNullOrUndefined(data["linkUrl"])) {
            Platforms.Platforms.gotoHistory({ target: data["linkUrl"] });
            if (Platforms.Platforms.handleOpenHistoryPage) {
                return;
            }
            window.open(data["linkUrl"], !Utils.isNullOrUndefined(data["linkTarget"]) ? data["linkTarget"] : "_blank");
        } else if (!StringUtils.isNullOrEmpty(AppContext.gameConfiguration.HistoryUrl)) {
            GameApp.openGameRoundHistoryFromUrl();
        } else if (!StringUtils.isNullOrEmpty(AppContext.gameConfiguration.RCIHistoryUrl)) {
            GameApp.openGameRoundHistoryFromUrl();
        } else {
            GameApp.openGameRoundHistory();
        }
    }

    protected static actionCashier(data: any): void {
        PlayList.play("SND_Click");

        if (!Utils.isNullOrUndefined(data["linkUrl"])) {
            Platforms.Platforms.gotoCasier({ reason: "InsufficientFunds", target: data["linkUrl"] });
            if (Platforms.Platforms.handleOpenCashierPage) {
                return;
            }
            window.open(data["linkUrl"], !Utils.isNullOrUndefined(data["linkTarget"]) ? data["linkTarget"] : "_self");
        } else if (!StringUtils.isNullOrEmpty(AppContext.gameConfiguration.CashierUrl)) {
            Platforms.Platforms.gotoCasier({
                reason: "InsufficientFunds",
                target: AppContext.gameConfiguration.CashierUrl,
            });
            if (Platforms.Platforms.handleOpenCashierPage) {
                return;
            }
            window.open(AppContext.gameConfiguration.CashierUrl, "_self");
        }
    }

    protected static actionLink(data: any): void {
        PlayList.play("SND_Click");

        if (!Utils.isNullOrUndefined(data["linkUrl"])) {
            window.open(data["linkUrl"], !Utils.isNullOrUndefined(data["linkTarget"]) ? data["linkTarget"] : "_blank");
        }
    }

    //******************************************************************************************************************
    //  HANDLE
    //******************************************************************************************************************

    protected static handle(): void {
        if (MessageManager.response.messages.length === MessageManager.step) {
            MessageManager.dialog.classList.add("_disabled");
            if (MessageManager.callback !== null) {
                MessageManager.callback(MessageManager.response);
            }
            if (MessageManager.dialogOpened) {
                Platforms.Platforms.dialogOpened("default", false);
            }
        } else {
            if (MessageManager.response.messages[MessageManager.step].type == "plugin") {
                Platforms.Platforms.sendPluginMessage(MessageManager.response.messages[MessageManager.step].text);
                MessageManager.step++;
                MessageManager.handle();
            } else {
                MessageManager.dialog.classList.remove("_disabled");
                MessageManager.updateDialogData(MessageManager.response.messages[MessageManager.step]);
                MessageManager.step++;
                Platforms.Platforms.dialogOpened("default", true);
                MessageManager.dialogOpened = true;
            }
        }
    }

    //******************************************************************************************************************
    //  CALLBACK
    //******************************************************************************************************************
    public static callbackFnc(response: any): void {
        BaseModel.spinContinue();
    }

    public static softResetCallbackFnc(response: any): void {
        FreeRoundBonus.refreshCurrentOffers(true);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Managers/MessageManager.ts
 **/